import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'case-disposition',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './case-disposition.component.html',
  styleUrl: './case-disposition.component.css'
})
export class CaseDispositionComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() caseClosingSummaryData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  @ViewChild('datepickerClosingDate') datepickerClosingDate!: ElementRef;

  yesNo = EYesNo;
  caseDispositionForm: FormGroup = new FormGroup([]);
  
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caseClosingSummaryData'] && this.caseClosingSummaryData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    group['closing_date'] = new FormControl(this.caseClosingSummaryData?.closing_date || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required);
    group['case_disposition_closing_notes'] = new FormControl(this.caseClosingSummaryData?.case_disposition_closing_notes || '', Validators.required);
  
    this.caseDispositionForm = new FormGroup(group);
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerClosingDate) {
        new Datepicker(this.datepickerClosingDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.caseClosingSummaryData?.closing_date) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerClosingDate.nativeElement.value = DateUtils.formatDateForDisplay(this.caseClosingSummaryData.closing_date);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerClosingDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerClosingDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.caseDispositionForm.get('closing_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveCaseDisposition(): void {
    if (this.caseDispositionForm.valid) {
      const data = this.caseDispositionForm.value;
      this.onSaveSection2.emit(data);
    }
  }

}
